// Palabras que conservan su mayúscula en tipo oración (nombres propios y siglas)
const PALABRAS_PROPIAS = {
  dios: "Dios",
  tierra: "Tierra",
  tic: "TIC",
};

/**
 * Convierte un texto a tipo oración: «RESUELVE PROBLEMAS DE CANTIDAD»
 * -> «Resuelve problemas de cantidad». Solo cambia cómo se muestra.
 */
export const aTipoOracion = (texto) => {
  const minusculas = String(texto ?? "").trim().toLocaleLowerCase("es");
  if (!minusculas) return "";

  const conPropias = minusculas.replace(
    /[\p{L}]+/gu,
    (palabra) => PALABRAS_PROPIAS[palabra] ?? palabra
  );

  return conPropias.charAt(0).toLocaleUpperCase("es") + conPropias.slice(1);
};
